/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AccountTransactionResponse
 */
export interface AccountTransactionResponse {
    /**
     * 
     * @type {string}
     * @memberof AccountTransactionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountTransactionResponse
     */
    'transactionType'?: AccountTransactionResponseTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountTransactionResponse
     */
    'operationType'?: AccountTransactionResponseOperationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountTransactionResponse
     */
    'paymentType'?: AccountTransactionResponsePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountTransactionResponse
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountTransactionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountTransactionResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AccountTransactionResponse
     */
    'editable'?: boolean;
}

export const AccountTransactionResponseTransactionTypeEnum = {
    BalanceTransfer: 'BALANCE_TRANSFER',
    DeliveryFee: 'DELIVERY_FEE',
    Discount: 'DISCOUNT',
    ManualAdjustment: 'MANUAL_ADJUSTMENT',
    MealCharge: 'MEAL_CHARGE',
    PlanSale: 'PLAN_SALE',
    PlatformFee: 'PLATFORM_FEE',
    Refund: 'REFUND',
    RefundToCreditCard: 'REFUND_TO_CREDIT_CARD',
    Consultation: 'CONSULTATION',
    InBodyAnalysis: 'IN_BODY_ANALYSIS',
    Promotion: 'PROMOTION',
    PromotionExpiry: 'PROMOTION_EXPIRY'
} as const;

export type AccountTransactionResponseTransactionTypeEnum = typeof AccountTransactionResponseTransactionTypeEnum[keyof typeof AccountTransactionResponseTransactionTypeEnum];
export const AccountTransactionResponseOperationTypeEnum = {
    Withdraw: 'WITHDRAW',
    Deposit: 'DEPOSIT'
} as const;

export type AccountTransactionResponseOperationTypeEnum = typeof AccountTransactionResponseOperationTypeEnum[keyof typeof AccountTransactionResponseOperationTypeEnum];
export const AccountTransactionResponsePaymentTypeEnum = {
    BankTransfer: 'BANK_TRANSFER',
    Cash: 'CASH',
    CreditCard: 'CREDIT_CARD',
    PaymentProvider: 'PAYMENT_PROVIDER',
    Other: 'OTHER'
} as const;

export type AccountTransactionResponsePaymentTypeEnum = typeof AccountTransactionResponsePaymentTypeEnum[keyof typeof AccountTransactionResponsePaymentTypeEnum];


